import { fetchOrgTypes } from '../../services/api/common';

export const orgTypes = {
    namespaced: true,
    state: {
        orgTypes: [],
    },
    mutations: {
        save(state, data) {
            state.orgTypes = data;
        }
    },
    actions: {
        fetchOrgTypes({ commit, dispatch }) {
            return fetchOrgTypes()
                .then((res) => {
                    commit('save', res.data);
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    throw res;
                });
        }
    },
    getters: {
        isFetched({ orgTypes }) {
            return !!orgTypes.length;
        },
        orgTypes({ orgTypes }) {
            return orgTypes;
        },
        orgTypesObject({ orgTypes }) {
            return orgTypes.reduce((items, item) => {
                items[item.id] = item.name;
                return items;
            }, {});
        },
        individualId({ orgTypes }) {
            const type = orgTypes.find((t) => t.name.trim().toUpperCase() === 'ИП');
            return type && type.id;
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/orgTypes/store.js